export const cityOptions = ['衡水市']

export const projectOptions = [
  { city: '衡水市', name: '衡水四季花语小区' },
  { city: '衡水市', name: '衡水君悦雅居小区' }
]

export const hikVehicles = [
  {
    id: 1, city: '衡水市', project: '衡水四季花语小区', plate: '冀TA12345', owner: '张三', room_no: 'FW-1-2-101',
    id_card: '131127199001011234', phone: '13800138001', nuoche_phone: '13800138001', parking_space: 'CW-1-1-001', expire_date: '2026-12-31',
    vehicle_type: '普通', in_garage: '否', abnormal: '',
    renewal_logs: [
      { operator: '张物业', operate_time: '2025-12-20 10:30:00', old_date: '2025-12-31', new_date: '2026-12-31' },
      { operator: '李主管', operate_time: '2024-12-15 09:15:00', old_date: '2024-12-31', new_date: '2025-12-31' }
    ]
  },
  {
    id: 2, city: '衡水市', project: '衡水四季花语小区', plate: '冀TB67890', owner: '李四', room_no: 'FW-1-2-102',
    id_card: '131127198805052345', phone: '13800138002', nuoche_phone: '13800138002', parking_space: 'CW-1-1-002', expire_date: '2026-06-30',
    vehicle_type: '租车位', in_garage: '是', abnormal: '',
    renewal_logs: [
      { operator: '张物业', operate_time: '2026-01-08 14:20:00', old_date: '2025-06-30', new_date: '2026-06-30' }
    ]
  },
  {
    id: 3, city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TC11223', owner: '王五', room_no: 'FW-9-1-902',
    id_card: '131127197612123456', phone: '13800138003', nuoche_phone: '13900139003', parking_space: 'CW-2-1-108', expire_date: '2025-12-31',
    vehicle_type: '普通', in_garage: '否', abnormal: '有效期异常',
    renewal_logs: []
  },
  {
    id: 4, city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TD44556', owner: '—', room_no: '—',
    id_card: '—', phone: '—', nuoche_phone: '—', parking_space: '—', expire_date: '2026-12-31',
    vehicle_type: '特殊', in_garage: '否', abnormal: '', attachment_name: '特殊车辆审批流程.pdf',
    renewal_logs: [
      { operator: '王经理', operate_time: '2026-03-01 11:00:00', old_date: '2026-03-31', new_date: '2026-12-31' }
    ]
  },
  {
    id: 5, city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TE77889', owner: '赵六', room_no: 'FW-5-3-602',
    id_card: '131127199503034567', phone: '13800138004', nuoche_phone: '13800138004', parking_space: 'CW-3-1-015', expire_date: '2026-09-30',
    vehicle_type: '普通', in_garage: '是', abnormal: '一位多车',
    renewal_logs: [
      { operator: '张物业', operate_time: '2026-04-10 16:45:00', old_date: '2026-03-31', new_date: '2026-09-30' },
      { operator: '张物业', operate_time: '2025-09-20 10:00:00', old_date: '2025-09-30', new_date: '2026-03-31' }
    ]
  }
]

export const jwsVehicles = [
  {
    id: 1, city: '衡水市', project: '衡水四季花语小区', plate: '冀TF99001', owner: '陈七', room_no: 'FW-2-1-201',
    id_card: '131127199204045678', phone: '13900139001', nuoche_phone: '13900139001', parking_space: 'CW-1-2-201', expire_date: '2026-08-31',
    person_code: 'P20260001', vehicle_type: '普通', in_garage: '否', abnormal: '',
    renewal_logs: [
      { operator: '张物业', operate_time: '2026-02-28 09:30:00', old_date: '2026-02-28', new_date: '2026-08-31' }
    ]
  },
  {
    id: 2, city: '衡水市', project: '衡水四季花语小区', plate: '冀TG88002', owner: '周八', room_no: 'FW-2-1-202',
    id_card: '131127198711115678', phone: '13900139002', nuoche_phone: '13900139002', parking_space: 'CW-1-2-202', expire_date: '2026-03-01',
    person_code: '', vehicle_type: '普通', in_garage: '是', abnormal: '缺少人员编码',
    renewal_logs: []
  },
  {
    id: 3, city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TH77003', owner: '—', room_no: '—',
    id_card: '—', phone: '—', nuoche_phone: '—', parking_space: '—', expire_date: '2026-12-31',
    person_code: '', vehicle_type: '特殊', in_garage: '否', abnormal: '', attachment_name: '特殊车辆审批截图.png',
    renewal_logs: [
      { operator: '王经理', operate_time: '2026-01-15 15:20:00', old_date: '2025-12-31', new_date: '2026-12-31' }
    ]
  },
  {
    id: 4, city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TJ66004', owner: '吴九', room_no: 'FW-6-2-1101',
    id_card: '131127199806066789', phone: '13900139003', nuoche_phone: '13900139003', parking_space: 'CW-2-2-008', expire_date: '2026-05-31',
    person_code: 'P20260004', vehicle_type: '租车位', in_garage: '否', abnormal: '车位信息不一致',
    renewal_logs: [
      { operator: '李主管', operate_time: '2025-11-30 08:50:00', old_date: '2025-11-30', new_date: '2026-05-31' }
    ]
  }
]

export const syncDiffList = [
  {
    id: 1, source: '海康', city: '衡水市', project: '衡水四季花语小区', plate: '冀TA12345', field: '有效期',
    local_value: '2026-06-30', remote_value: '2026-12-31', sync_time: '2026-06-25 10:30:00',
    local_data: { plate: '冀TA12345', owner: '张三', room_no: 'FW-1-2-101', phone: '13800138001', parking_space: 'CW-1-1-001', expire_date: '2026-06-30', vehicle_type: '普通' },
    remote_data: { plate: '冀TA12345', owner: '张三', room_no: 'FW-1-2-101', phone: '13800138001', parking_space: 'CW-1-1-001', expire_date: '2026-12-31', vehicle_type: '普通' }
  },
  {
    id: 2, source: '海康', city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TC11223', field: '业主姓名',
    local_value: '王五', remote_value: '王伍', sync_time: '2026-06-25 10:30:00',
    local_data: { plate: '冀TC11223', owner: '王五', room_no: 'FW-9-1-902', phone: '13800138003', parking_space: 'CW-2-1-108', expire_date: '2025-12-31', vehicle_type: '普通' },
    remote_data: { plate: '冀TC11223', owner: '王伍', room_no: 'FW-9-1-902', phone: '13800138003', parking_space: 'CW-2-1-108', expire_date: '2025-12-31', vehicle_type: '普通' }
  },
  {
    id: 3, source: '捷卫士', city: '衡水市', project: '衡水四季花语小区', plate: '冀TG88002', field: '车位编号',
    local_value: 'CW-1-2-202', remote_value: 'CW-1-2-203', sync_time: '2026-06-25 11:00:00',
    local_data: { plate: '冀TG88002', owner: '周八', room_no: 'FW-2-1-202', phone: '13900139002', parking_space: 'CW-1-2-202', expire_date: '2026-03-01', vehicle_type: '普通', person_code: '' },
    remote_data: { plate: '冀TG88002', owner: '周八', room_no: 'FW-2-1-202', phone: '13900139002', parking_space: 'CW-1-2-203', expire_date: '2026-03-01', vehicle_type: '普通', person_code: 'P20260002' }
  },
  {
    id: 4, source: '捷卫士', city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TJ66004', field: '车牌号',
    local_value: '冀TJ66004', remote_value: '冀TJ66005', sync_time: '2026-06-25 11:00:00',
    local_data: { plate: '冀TJ66004', owner: '吴九', room_no: 'FW-6-2-1101', phone: '13900139003', parking_space: 'CW-2-2-008', expire_date: '2026-05-31', vehicle_type: '租车位', person_code: 'P20260004' },
    remote_data: { plate: '冀TJ66005', owner: '吴九', room_no: 'FW-6-2-1101', phone: '13900139003', parking_space: 'CW-2-2-008', expire_date: '2026-05-31', vehicle_type: '租车位', person_code: 'P20260004' }
  }
]

export const hikSyncLogs = [
  { id: 1, project: '衡水四季花语小区', sync_count: 156, abnormal_count: 1, start_time: '2026-06-24 22:00:00', end_time: '2026-06-24 22:01:30' },
  { id: 2, project: '衡水君悦雅居小区', sync_count: 128, abnormal_count: 1, start_time: '2026-06-24 22:02:00', end_time: '2026-06-24 22:03:20' },
  { id: 3, project: '衡水四季花语小区', sync_count: 156, abnormal_count: 0, start_time: '2026-06-20 10:00:00', end_time: '2026-06-20 10:01:45' },
  { id: 4, project: '衡水君悦雅居小区', sync_count: 127, abnormal_count: 2, start_time: '2026-06-20 10:02:30', end_time: '2026-06-20 10:04:10' }
]

export const jwsSyncLogs = [
  { id: 1, project: '衡水四季花语小区', sync_count: 142, abnormal_count: 1, start_time: '2026-06-24 22:10:00', end_time: '2026-06-24 22:11:25' },
  { id: 2, project: '衡水君悦雅居小区', sync_count: 118, abnormal_count: 1, start_time: '2026-06-24 22:12:00', end_time: '2026-06-24 22:13:15' },
  { id: 3, project: '衡水四季花语小区', sync_count: 141, abnormal_count: 0, start_time: '2026-06-20 11:00:00', end_time: '2026-06-20 11:01:40' },
  { id: 4, project: '衡水君悦雅居小区', sync_count: 117, abnormal_count: 1, start_time: '2026-06-20 11:02:20', end_time: '2026-06-20 11:03:55' }
]

export const accessRecords = [
  { id: 1, plate: '冀TA12345', direction: '入场', gate: '东门入口', time: '2026-06-25 08:12:33' },
  { id: 2, plate: '冀TA12345', direction: '出场', gate: '东门出口', time: '2026-06-25 18:45:10' },
  { id: 3, plate: '冀TB67890', direction: '入场', gate: '地库入口', time: '2026-06-25 09:20:15' },
  { id: 4, plate: '冀TF99001', direction: '出场', gate: '西门出口', time: '2026-06-25 16:30:00' }
]

export const parkingSpaces = [
  {
    id: 1,
    city: '衡水市',
    project: '衡水四季花语小区',
    space_no: 'CW-1-1-001',
    owner: '张三',
    phone: '13800138001',
    room_no: 'FW-1-2-101',
    sync_time: '2026-06-24 22:00:00',
    rent: { status: '空闲', tenant: '', phone: '', id_card: '', rent_start: '', rent_end: '' },
    parent_child: { is_parent_child: '是', max_cars: 2, related_spaces: 'CW-1-1-001/CW-1-1-002' },
    vehicles: [
      { plate: '冀TA12345', owner: '张三', source: '海康', in_garage: '否', expire_date: '2026-12-31', vehicle_type: '普通' },
      { plate: '冀TA12346', owner: '张三', source: '捷卫士', in_garage: '否', expire_date: '2026-12-31', vehicle_type: '普通' }
    ]
  },
  {
    id: 2,
    city: '衡水市',
    project: '衡水四季花语小区',
    space_no: 'CW-1-1-002',
    owner: '李四',
    phone: '13800138002',
    room_no: 'FW-1-2-102',
    sync_time: '2026-06-24 22:00:00',
    rent: { status: '已租', tenant: '刘明', phone: '13700137001', id_card: '131127199101011111', rent_start: '2026-01-01', rent_end: '2026-12-31' },
    parent_child: { is_parent_child: '是', max_cars: 2, related_spaces: 'CW-1-1-001/CW-1-1-002' },
    vehicles: [
      { plate: '冀TR10001', owner: '刘明', source: '捷卫士', in_garage: '是', expire_date: '2026-12-31', vehicle_type: '租车位' }
    ]
  },
  {
    id: 3,
    city: '衡水市',
    project: '衡水君悦雅居小区',
    space_no: 'CW-2-1-108',
    owner: '王五',
    phone: '13800138003',
    room_no: 'FW-9-1-902',
    sync_time: '2026-06-24 22:00:00',
    rent: { status: '空闲', tenant: '', phone: '', id_card: '', rent_start: '', rent_end: '' },
    parent_child: { is_parent_child: '否', max_cars: 2, related_spaces: 'CW-2-1-108' },
    vehicles: [
      { plate: '冀TC11223', owner: '王五', source: '海康', in_garage: '否', expire_date: '2025-12-31', vehicle_type: '普通' }
    ]
  }
]

export const parkingSpaceSyncHistory = [
  { id: 1, project: '衡水四季花语小区', total: 320, synced: 320, start_time: '2026-06-24 22:00:00', end_time: '2026-06-24 22:05:20', status: '已完成' },
  { id: 2, project: '衡水君悦雅居小区', total: 256, synced: 256, start_time: '2026-06-24 22:10:00', end_time: '2026-06-24 22:14:35', status: '已完成' }
]

export const parkingSpaceSyncTotals = {
  '衡水四季花语小区': 320,
  '衡水君悦雅居小区': 256
}

export const parkingFeeList = [
  {
    id: 1, city: '衡水市', project: '衡水四季花语小区', space_no: 'CW-1-1-001', owner: '张三', phone: '13800138001', tenant_phone: '',
    fee_amount: '1200.00', space_expire_date: '2026-12-31', expire_date: '2026-12-31', arrears: '0.00', sync_time: '2026-06-25 06:00:00',
    vehicles: [
      { plate: '冀TA12345', owner: '张三', source: '海康', in_garage: '否', expire_date: '2026-12-31', vehicle_type: '普通' }
    ]
  },
  {
    id: 2, city: '衡水市', project: '衡水四季花语小区', space_no: 'CW-1-3-001', owner: '—', phone: '', tenant_phone: '13700137001',
    fee_amount: '1200.00', space_expire_date: '2026-12-31', expire_date: '2026-06-30', arrears: '0.00', sync_time: '2026-06-25 06:00:00',
    vehicles: [
      { plate: '冀TR10001', owner: '刘明', source: '捷卫士', in_garage: '是', expire_date: '2026-12-31', vehicle_type: '租车位' }
    ]
  },
  {
    id: 3, city: '衡水市', project: '衡水君悦雅居小区', space_no: 'CW-2-1-108', owner: '王五', phone: '13800138003', tenant_phone: '',
    fee_amount: '1200.00', space_expire_date: '2026-12-31', expire_date: '2025-12-31', arrears: '1200.00', sync_time: '2026-06-25 06:00:00',
    vehicles: [
      { plate: '冀TC11223', owner: '王五', source: '海康', in_garage: '否', expire_date: '2025-12-31', vehicle_type: '普通' },
      { plate: '冀TC11224', owner: '王五', source: '捷卫士', in_garage: '否', expire_date: '2025-12-31', vehicle_type: '普通' }
    ]
  },
  {
    id: 4, city: '衡水市', project: '衡水君悦雅居小区', space_no: 'CW-3-1-015', owner: '赵六', phone: '13800138004', tenant_phone: '',
    fee_amount: '960.00', space_expire_date: '2027-03-31', expire_date: '2026-09-30', arrears: '0.00', sync_time: '2026-06-25 06:00:00',
    vehicles: [
      { plate: '冀TE77889', owner: '赵六', source: '海康', in_garage: '是', expire_date: '2026-09-30', vehicle_type: '普通' }
    ]
  }
]

export const parkingFeeSyncHistory = [
  { id: 1, project: '衡水四季花语小区', total: 320, synced: 320, start_time: '2026-06-24 22:00:00', end_time: '2026-06-24 22:05:20', status: '已完成' },
  { id: 2, project: '衡水君悦雅居小区', total: 256, synced: 256, start_time: '2026-06-24 22:10:00', end_time: '2026-06-24 22:14:35', status: '已完成' }
]

export const parkingFeeSyncTotals = {
  '衡水四季花语小区': 320,
  '衡水君悦雅居小区': 256
}

export const statisticsSummary = [
  { id: 1, city: '衡水市', project: '衡水四季花语小区', total_spaces: 320, registered_cars: 298, expire_abnormal: 5, count_abnormal: 3, special_cars: 2 },
  { id: 2, city: '衡水市', project: '衡水君悦雅居小区', total_spaces: 256, registered_cars: 241, expire_abnormal: 8, count_abnormal: 4, special_cars: 1 }
]

export const reportList = [
  { id: 1, report_name: '有效期异常明细', city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TC11223', owner: '王五', abnormal_type: '有效期异常', generate_time: '2026-06-25 09:00:00' },
  { id: 2, report_name: '一位多车明细', city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TE77889', owner: '赵六', abnormal_type: '录入数量异常', generate_time: '2026-06-25 09:00:00' },
  { id: 3, report_name: '特殊车辆明细', city: '衡水市', project: '衡水君悦雅居小区', plate: '冀TD44556', owner: '—', abnormal_type: '特殊车辆', generate_time: '2026-06-25 09:00:00' }
]

export const permissionList = [
  { id: 1, account: 'wuye_zhang', name: '张物业', role: '物业运营', projects: '衡水四季花语小区、衡水君悦雅居小区', update_time: '2026-06-20 14:00:00' },
  { id: 2, account: 'caiwu_li', name: '李财务', role: '财务管理', projects: '衡水四季花语小区、衡水君悦雅居小区', update_time: '2026-06-20 14:00:00' },
  { id: 3, account: 'admin', name: '系统管理员', role: '系统管理员', projects: '全部项目', update_time: '2026-06-01 10:00:00' }
]
